//
// Generated by @himenon/openapi-typescript-code-generator v0.27.4
//
// OpenApi : 3.0.0
//
//
import {
  Params$AdminPayslipDocumentController_delete,
  Response$AdminPayslipDocumentController_delete$Status$200,
  ResponseContentType$AdminPayslipDocumentController_delete,
} from '@api-client/generated/client';
import { useApiClientMutation } from '@hooks/useApiClientMutation';

export const useAdminPayslipDocumentController_delete = () =>
  useApiClientMutation<
    Params$AdminPayslipDocumentController_delete,
    Response$AdminPayslipDocumentController_delete$Status$200[ResponseContentType$AdminPayslipDocumentController_delete]
  >({ method: 'AdminPayslipDocumentController_delete' });
